import tw from "twin.macro";

export const withFocusRing = (component) => {
  return tw(component)`
    focus-visible:outline-1 focus-visible:outline-current focus-visible:outline-offset-1 focus-visible:outline-dashed
  `;
};
